import React from 'react';
import { Popup } from 'framework7-react';
import './SignaturePopup.css';
import Signature from '../../signature/Signature';
import FormTemplate from '../../templates/formTemplates/FormTemplate';
import Content from '../../helpers/content/Content';
import Label from '../../label/Label';
import PrimaryButton from '../../primaryButton/PrimaryButton';
import SecondaryButton from "../../secondaryButton/SecondaryButton";

export default class SignaturePopup extends FormTemplate {
	constructor(props) {
		super(props);
		this.myRefs = {};
		this.state = {
			hasStarted: false
		};
	}

	close = () => {
		window.popupController.hide(SignaturePopup);
	};

	finish = () => {
		const img = this.myRefs.guest_verify__signature_img.getValue();
		this.props.onFinish(img);
	};

	componentDidUpdate(prevProps) {
		// Reset state when popup opens
		if (this.props.opened && !prevProps.opened) {
			this.setState({ hasStarted: false });
		}
	}

	handleSignatureBegin = () => {
		this.setState({ hasStarted: true });
	};

	clear = () => {
		if (this.myRefs.guest_verify__signature_img) {
			this.myRefs.guest_verify__signature_img.clear();
			this.setState({ hasStarted: false });
		}
	};

	render() {
		return (
			<Popup className={'g-signature-popup'} opened={this.props.opened} tabletFullscreen={true}>
				<Content>
					<Label dark large center>
						Signature
					</Label>
					<Signature required ref={(ref) => (this.myRefs.guest_verify__signature_img = ref)} onBegin={this.handleSignatureBegin} />
				
						<PrimaryButton onClick={this.finish}>Done</PrimaryButton>
						{this.state.hasStarted && (
							<SecondaryButton className={'clear-button'} onClick={this.clear}>Clear</SecondaryButton>
						)}
				</Content>
			</Popup>
		);
	}
}
